import { TeamModel, ProjectModel, ProjectFileModel, ProjectTaskModel } from "../../model/CronosModel";

export interface CronosState {
    loadingTeams: boolean;
    errorLoadingTeams: boolean;
    teams: Array<TeamModel>;
    loadingProjects: boolean;
    errorLoadingProjects: boolean;
    projects: Array<ProjectModel>;
    savingReoder: boolean;
    errorReorder: boolean;
    savingTask: boolean;
    errorTask: boolean;
    removingTask: boolean;
    errorRemovingTask: boolean;
    savingComment: boolean;
    errorComment: boolean;
    savingFile: boolean;
    errorFile: boolean;
    fileData: ProjectFileModel;
    savedTaskData: ProjectTaskModel;
    savingProject: boolean;
    errorSavingProject: boolean;
    savedProjectData: ProjectModel;
}

export const initialState: CronosState = {
    loadingTeams: false,
    errorLoadingTeams: false,
    teams: null,
    loadingProjects: false,
    errorLoadingProjects: false,
    projects: null,
    savingReoder: false,
    errorReorder: false,
    savingTask: false,
    errorTask: false,
    removingTask: false,
    errorRemovingTask: false,
    savingComment: false,
    errorComment: false,
    savingFile: false,
    errorFile: false,
    fileData: null,
    savedTaskData: null,
    savingProject: false,
    errorSavingProject: false,
    savedProjectData: null
}


// WEBPACK FOOTER //
// ./src/store/state/CronosState.ts